var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "track-query-wrapper" },
    [
      _c("track-route-header", {
        attrs: { "route-info": _vm.computedRouteInfo },
      }),
      _vm.showMapTab
        ? _c("div", { staticClass: "track-tabs-container" }, [
            _c("div", { staticClass: "track-tabs-nav" }, [
              _c(
                "div",
                {
                  class: [
                    "track-tab-item",
                    { active: _vm.activeTab === "all" },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.handleTabChange("all")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-check tab-icon" }),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("trajectory.all")) +
                        " (" +
                        _vm._s(_vm.timelineList.length) +
                        ")"
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  class: [
                    "track-tab-item",
                    { active: _vm.activeTab === "map" },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.handleTabChange("map")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-map-location tab-icon" }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("trajectory.trajectoryMap"))),
                  ]),
                ]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeTab === "all",
                    expression: "activeTab === 'all'",
                  },
                ],
                staticClass: "track-view-pane",
              },
              [
                _c("track-timeline", {
                  attrs: { "timeline-list": _vm.timelineList },
                  on: {
                    "view-photo": _vm.handleViewPhoto,
                    "view-problem-photo": _vm.handleViewProblemPhoto,
                  },
                }),
              ],
              1
            ),
            _vm.hasLoadedMap
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab === "map",
                        expression: "activeTab === 'map'",
                      },
                    ],
                    staticClass: "track-view-pane track-map-pane",
                  },
                  [
                    _c("maps-trajectory", {
                      attrs: { "query-track-param": _vm.queryTrackParam },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _c(
            "div",
            { staticClass: "track-single-view" },
            [
              _c("track-timeline", {
                attrs: { "timeline-list": _vm.timelineList },
                on: {
                  "view-photo": _vm.handleViewPhoto,
                  "view-problem-photo": _vm.handleViewProblemPhoto,
                },
              }),
            ],
            1
          ),
      _c("imageSeeDialog", { ref: "imageSeeDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }